module.exports = __webpack_public_path__ + "img/bpd_logo.ed224540.png";